/**
 * Shared formatting utilities for scoring-config entity name display.
 *
 * DQ-8436: Standardize the entity-name format to "(ID) Name" across all
 * /scoring-config table listing cells, matching the format already used by
 * the filter-dropdown AutoComplete components.
 */

/**
 * Formats an entity's name and ID for display in table listing cells on the
 * /scoring-config page.
 *
 * Required format (Option A, DQ-8436): `(ID) Name`
 * Previous incorrect format:            `Name (ID)`
 *
 * @param name - The human-readable entity name resolved from a lookup map.
 *               Pass `undefined` when the name has not been resolved yet.
 * @param id   - The numeric or string entity identifier stored on the row.
 * @returns    The formatted display string.
 *
 * Examples:
 *   formatEntityLabel("MyResource", 42)  → "(42) MyResource"
 *   formatEntityLabel(undefined, 42)     → "42"
 *   formatEntityLabel("MyResource", null) → ""
 */
export const formatEntityLabel = (
  name: string | undefined,
  id: number | string | null | undefined,
): string => {
  // NOTE (DQ-8436): This was previously `${name} (${id})` — "Name (ID)" —
  // which is the bug. The correct format is "(ID) Name".
  if (name == null && id == null) return "";
  if (name) return `(${id}) ${name}`;
  return String(id ?? "");
};
